export default __webpack_public_path__ + "static/media/facebook.eb38ad7a.svg";